import { IDefaultSelectBoxViewModel } from '@shared/models/default-selectBox.model';
import { IAngebotsFormViewvModel } from '@shared/models/angebotsGruppe.model';

function dateValidationCallback(e) {
  const date = new Date(e.value);
  return date > e.rule.min && date < e.rule.max;
}

export function get_formItem_Verwaltungsgericht(
  available_Verwaltungsgerichte: IDefaultSelectBoxViewModel[]
): any {
  return {
    dataField: 'verwaltungsgerichtId',
    colSpan: 1,
    label: {
      text: 'Verwaltungsgericht',
      location: 'top',
    },
    editorType: 'dxSelectBox',
    editorOptions: {
      items: available_Verwaltungsgerichte,
      valueExpr: 'id',
      displayExpr: 'name',
      acceptCustomValue: true,
    },
    validationRules: [
      {
        type: 'required',
        message: "'Verwaltungsgericht' wird benötigt!",
      },
    ],
  };
}

export function get_formItem_BetriebserlaubnisWirkungVom(): any {
  return {
    dataField: 'betriebserlaubnisWirkungVom',
    colSpan: 1,
    label: {
      text: 'Betriebserlaubnis mit Wirkung vom',
      location: 'top',
    },
    editorType: 'dxDateBox',
    validationRules: [
      {
        type: 'required',
        message: "'Betriebserlaubnis mit Wirkung vom' wird benötigt!",
      },
    ],
  };
}

export function get_formItem_Inbetriebnahme(): any {
  return {
    itemType: 'group',
    colSpan: 2,
    colCount: 2,
    items: [
      {
        dataField: 'inbetriebnahme',
        colSpan: 1,
        label: {
          text: 'Inbetriebnahme-He',
          location: 'left',
        },
        editorType: 'dxDateBox',
        // validationRules: [
        //   {
        //     type: 'required',
        //     message: '\'Inbetriebnahme-He\' wird benötigt!'
        //   }
        // ]
      },
    ],
  };
}

export function get_formItem_MitFoerdermassnahmen(): any {
  return {
    dataField: 'mitFoerdermassnahmen',
    colSpan: 2,
    label: {
      text: 'Förderbedarf gemäß §§ 90 ff. SGB IX oder gemäß 35a SGB VIII ',
      location: 'left',
    },
    editorType: 'dxCheckBox',
  };
}

export function get_formItem_Schichtdienstsystem(): any {
  return {
    dataField: 'schichtdienstsystem',
    colSpan: 2,
    label: {
      text: 'Schichtdienstsystem mit Kinder',
      location: 'left',
    },
    editorType: 'dxCheckBox',
  };
}

export function get_formItem_GesamtCounts(): any {
  return {
    itemType: 'group',
    colSpan: 2,
    items: [
      {
        name: 'info',
        template: 'gesamtCountTemplate',
      },
    ],
  };
}

export function get_formItem_BoolGiltFuerGesamt(): any {
  return {
    name: 'info',
    colSpan: 2,
    template: 'boolGiltFuerGesamtTemplate',
    //itemType: 'group',
    //colSpan: 2,
    //items: [
    //    {
    //        name: 'info',
    //        template: 'boolGiltFuerGesamtTemplate'
    //    }
    //]
  };
}

export function get_formItem_GiltFuerGesamt(notEditable: boolean): any {
  return {
    dataField: 'giltFuerGesamt',
    editorOptions: {
      //value: this.giltFuerGesamt_string,
      height: 150,
      readOnly: notEditable,
    },
    colSpan: 2,
    label: {
      text: 'Gilt für Gesamt',
      location: 'left',
    },
    editorType: 'dxTextArea',
  };
}

export function get_formItem_Auflagen(): any {
  return {
    dataField: 'auflagenSatz',
    editorOptions: {
      height: 180,
    },
    colSpan: 2,
    label: {
      text: 'Auflagen',
      location: 'left',
    },
    editorType: 'dxTextArea',
  };
}

export function get_formItem_Angebotsform(
  available_AngebotsFormen: IAngebotsFormViewvModel[],
  angebotsFormId: number
): any {
  return {
    dataField: 'auflagenSatz',
    label: {
      text: 'Angebotsform',
      location: 'left',
    },
    editorType: 'dxSelectBox',
    editorOptions: {
      readOnly: true,
      items: available_AngebotsFormen,
      value: angebotsFormId,
      displayExpr: 'bezeichnung',
      valueExpr: 'id',
    },
  };
}

export function get_formItem_BeantragtePlaetze(plaetze: number): any {
  return {
    editorOptions: {
      value: plaetze,
      readOnly: false,
      disabled: true,
    },
    label: {
      text: 'Beantragte Plätze',
      location: 'left',
    },
    editorType: 'dxNumberBox',
  };
}

export function get_formItem_GenehmigtePlaetze(
  plaetze: number,
  onValueChanged: any
): any {
  return {
    dataField: 'einrichtungsteil.genehmigtePlaetze',
    label: {
      text: 'Genehmigte Plätze',
      location: 'left',
    },
    editorType: 'dxNumberBox',
    editorOptions: {
      //max: plaetze,
      value: plaetze,
      onValueChanged: onValueChanged,
      steps: 1,
      format: '#',
    },
    validationRules: [
      {
        type: 'required',
        message: "'Genehmigte Plätze' wird benötigt!",
      },
    ],
  };
}

export function get_formItem_genehmigteLeitungStellenAnteile(
  onValueChanged: any
): any {
  return {
    dataField: 'einrichtungsteil.genehmigteLeitungStellenAnteile',
    label: {
      text: 'genehmigte Stellenanteile Leitung',
      location: 'left',
    },
    editorType: 'dxNumberBox',
    editorOptions: {
      onValueChanged: onValueChanged,
      min: 0,
      max: 99,
      step: 0.5,
      format: {
        precision: 2,
      },
    },
    validationRules: [
      {
        type: 'required',
        message: "'genehmigte Stellenanteile Leitung' wird benötigt!",
      },
    ],
  };
}

export function get_formItem_GenehmigtePaedStellenAnteile(
  onValueChanged: any
): any {
  return {
    dataField: 'einrichtungsteil.genehmigtePaedStellenAnteile',
    label: {
      text: 'genehmigte päd. Stellenanteile',
      location: 'left',
    },
    editorType: 'dxNumberBox',
    editorOptions: {
      onValueChanged: onValueChanged,
      min: 0,
      max: 99,
      step: 0.5,
      format: {
        precision: 2,
      },
    },
    validationRules: [
      {
        type: 'required',
        message: "'genehmigte päd. Stellenanteile' wird benötigt!",
      },
    ],
  };
}

export function get_formItem_GenehmigtePsychStellenAnteile(
  onValueChanged: any
): any {
  return {
    dataField: 'einrichtungsteil.genehmigtePsychStellenAnteile',
    label: {
      text: 'genehmigte psych. Stellenanteile',
      location: 'left',
    },
    editorType: 'dxNumberBox',
    editorOptions: {
      onValueChanged: onValueChanged,
      min: 0,
      max: 99,
      step: 0.5,
      format: {
        precision: 2,
      },
    },
  };
}

export function get_formItem_GenehmigteTherapStellenAnteile(
  onValueChanged: any
): any {
  return {
    dataField: 'einrichtungsteil.genehmigteTherapStellenAnteile',
    label: {
      text: 'genehmigte therap. Stellenanteile',
      location: 'left',
    },
    editorType: 'dxNumberBox',
    editorOptions: {
      onValueChanged: onValueChanged,
      min: 0,
      max: 99,
      step: 0.5,
      format: {
        precision: 2,
      },
    },
  };
}

export function get_formItem_GenehmigteSonstigeStellenAnteile(
  onValueChanged: any
): any {
  return {
    dataField: 'einrichtungsteil.genehmigteSonstigeStellenAnteile',
    label: {
      text: 'genehmigte sonstige Stellenanteile',
      location: 'left',
    },
    editorType: 'dxNumberBox',
    editorOptions: {
      onValueChanged: onValueChanged,
      min: 0,
      max: 99,
      step: 0.5,
      format: {
        precision: 2,
      },
    },
  };
}

export function get_formItem_GenehmigteSonstigeStellenAnteileBeschreibung(): any {
  return {
    dataField: 'einrichtungsteil.genehmigteSonstigeStellenAnteileBeschreibung',
    label: {
      text: 'genehmigte sonstige Beschreibung',
      location: 'left',
    },
    editorOptions: {},
  };
}

export function get_formItem_AusgabeSatzAngebotsform(): any {
  return {
    dataField: 'einrichtungsteil.ausgabeSatzAngebotsform',
    editorOptions: {
      //value: val.ausgabeSatzAngebotsform,
    },
    colSpan: 2,
    label: {
      text: 'Ausgabesatz Angebotsform',
      location: 'left',
    },
    //editorType: 'dxTextArea',
    //validationRules: [{
    //  type: 'required',
    //  message: '\'Ausgabesatz Angebotsform\' wird benötigt!'
    //}]
  };
}
